import { FiBriefcase, FiBookOpen, FiGlobe, FiHeart } from 'react-icons/fi'
import type { Service } from '@/types/what-we-do'

export const services: Service[] = [
  {
    no: '01',
    title: ['Entrepreneurship', '& Innovation'],
    description:
      'We help entrepreneurs, startups, and innovators access mentorship, training, business development support, and professional networks that increase their ability to launch and grow sustainable ventures.',
    Icon: FiBriefcase,
    ring: false,
  },
  {
    no: '02',
    title: ['Education', '& Leadership'],
    description:
      'We equip students and emerging leaders with practical knowledge, leadership skills, and the confidence to seize opportunities and become agents of change across the regions we serve.',
    Icon: FiBookOpen,
    ring: true,
  },
  {
    no: '03',
    title: ['Cultural', 'Exchange'],
    description:
      'Through festivals, collaborative initiatives, and cross-regional engagement, we promote cultural understanding and strengthen people-to-people connections between Africa and the Caribbean.',
    Icon: FiGlobe,
    ring: false,
  },
  {
    no: '04',
    title: ['Humanitarian', 'Advocacy'],
    description:
      'We support advocacy efforts that protect vulnerable populations, raise awareness of critical issues, and encourage action that promotes dignity, safety, and human rights.',
    Icon: FiHeart,
    ring: true,
  },
]
